export default __webpack_public_path__ + "static/media/bracers_of_ferine_anger.dc556b3b.jpg";